import { TicketPayment } from 'modules/tickets/services/types';

export const featureName = 'customer';
export const CUSTOMER_PAGE_SIZE = 20;
export const TICKET_PAGE_SIZE = 25;
export interface ICustomerListResponse {
  totalElements: number;
  totalPages: number;
  point?: string;
  amount?: string;
  pageable: {
    sort: {
      sorted: boolean;
      empty: boolean;
      unsorted: boolean;
    };
    pageNumber: number;
    pageSize: number;
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  content: ICustomerType[];
}

export interface ICustomerType {
  id: string;
  storeId: string | null;
  birthday: string;
  name: string;
  email: string;
  phone: string;
  numberVisit: number;
  point: number;
  qrCode: string;
  avatar: string | null;
  amount: number;
  createdDate: string;
  lastVisitedDate: string;
  address: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  note: string | null;
  active: boolean;
}

export interface ICustomerTicketListResponse {
  totalElements: number;
  totalPages: number;
  pageable: {
    sort: {
      sorted: boolean;
      empty: boolean;
      unsorted: boolean;
    };
    pageNumber: number;
    pageSize: number;
    offset: number;
    paged: boolean;
    unpaged: boolean;
  };
  content: ICustomerTicketType[];
}

export interface ICustomerTicketType {
  billId: string;
  customerName: string;
  customerPhone: string;
  staffId: string;
  staffName: string;
  avatar: string;
  ticketNumber: number;
  createdDated: string;
  total: number;
  subTotal: number;
  discount: number;
  cardFee: number;
  tax: number;
  enableVoid: boolean;
  enableRefund: boolean;
  items: ItemTicketRpType[];
  payments: PaymentDetailRpType[];
}

export interface ItemTicketRpType {
  itemId: string;
  itemName: string;
  itemType: 'PRODUCT' | 'GIFT_CARD' | 'VIP';
  price: number;
  discount: number;
  quantity: number;
}

export interface PaymentDetailRpType extends TicketPayment {
  otherMethod: string;
  amount: number;
  chance: number;
  feeCredit: number;
  giftCardId: string;
  cashIncentiveDiscount: boolean;
  chargeFee: boolean;
  checkInfo: {
    dlInformation: string;
    address: string;
    bankName: string;
    payTo: string;
    checkNumber: string;
    routingNumber: string;
    accountNumber: string;
    forValue: string;
  };
  discountIncentive: number;
}

export interface GetCustomerListParams {
  page: number;
  size: number;
  keySearch?: string;
  status?: string;
  sortKey?: string;
  sortBy?: string;
}

export interface GetTicketByCustomerIdParams {
  customerId: string;
  page: number;
  size: number;
}

export type CreateCustomerBody = {
  name: string;
  phone: string;
  email: string;
  dob: string;
};

export type UpdateCustomerBody = {
  id: string;
} & CreateCustomerBody;

export interface ICustomerSummary {
  totalCustomer: number;
  totalReturn: number;
  totalNotReturn: number;
  totalBirthComing: number;
}
